import React, { FC }              from 'react';
import { formatOption }           from '../../../../util';
import { SelectField }            from '../../../components/forms';
import { PreSelectedSelectField } from '../../../../types';

const Dropdown: FC<PreSelectedSelectField> = ( props ) => {
	
	let options = [
		formatOption( 1, '-1 Year to Launch' ),
		formatOption( 2, '-2 Year to Launch' ),
		formatOption( 3, '-3 Year to Launch' ),
		formatOption( 4, '-4 Year to Launch' ),
		formatOption( 5, '-5 Year to Launch' ),
	];
	
	return (
		<SelectField
			{ ...props }
			options={ options }>
		</SelectField>
	);
};

export { Dropdown as ItemStartYearDropdown };
